// src/index.tsx
import { chakra, useMultiStyleConfig } from "@chakra-ui/react";
import { jsx, jsxs } from "react/jsx-runtime";
var InfoBox = ({ children, variant = "primary", icon, isChat, ...props }) => {
  const styles = useMultiStyleConfig("InfoBox", { variant });
  const borderTopLeftRadius = isChat ? 0 : "lg";
  return /* @__PURE__ */ jsxs(chakra.div, { "data-testid": "infobox", __css: styles.container, borderTopLeftRadius, ...props, children: [
    icon && /* @__PURE__ */ jsx(chakra.div, { __css: styles.icon, children: icon }),
    /* @__PURE__ */ jsx(chakra.div, { flex: 1, children })
  ] });
};
export {
  InfoBox
};
